import { atom } from "jotai";
import { atomFamily } from "jotai-family";

/**
 * Shared popup payload. Each popup narrows this to its own props interface at
 * the point it reads the atom.
 */
export interface PopupInfo {
  id?: string;
  active?: boolean;
  allow?: boolean;
  title?: string;
  message?: string;
  onClose?: () => void;
  [key: string]: unknown;
}

const popupsAtom = atomFamily((_id: string | undefined) => atom<PopupInfo>({}));

const popupIdsAtom = atom<(string | undefined)[]>([]);

const activePopupState = atomFamily((id: string | null = null) =>
  atom(
    (get): PopupInfo | null => {
      if (id) {
        return get(popupsAtom(id));
      }
      const list = get(popupIdsAtom);
      let findItem: PopupInfo | null = null;
      list.find((popupId) => {
        const info = get(popupsAtom(popupId));
        if (info.active) {
          findItem = info;
        }
        return info.active;
      });
      return findItem;
    },
    (_get, set, info: PopupInfo) => {
      if (id) {
        info.id = id;
      }
      set(popupsAtom(info.id), info);
      set(popupIdsAtom, (prev) =>
        [...prev, info.id].filter(function (value, index, self) {
          return self.indexOf(value) === index;
        }),
      );
    },
  ),
);

export { activePopupState };
